import formatAsCurrency from "@wss/utilities/formatAsCurrency";

export type StatusState = {
  showSubmissionMessage: boolean;
  submissionHeader: string;
  submissionMessage: string;
  statusFetchComplete: boolean;
  creditsEarned: string;
  loggedInWithModal: boolean;
};

export type StatusAction =
  | {
      type: "FETCH_STATUS";
      payload: {
        reviewStatus: string;
        creditsGranted: number | undefined;
      } | null;
    }
  | {
      type: "REVIEW_SUBMISSION";
      payload: {
        success: boolean;
      };
    }
  | {
      type: "FETCH_ERROR";
    }
  | {
      type: "MODAL_LOGIN";
      payload: {
        loggedInWithModal: boolean;
      };
    }
  | {
      type: "RESET_STATUS";
    };

export const defaultStatusState: StatusState = {
  showSubmissionMessage: false,
  submissionHeader: "",
  submissionMessage: "",
  statusFetchComplete: false,
  creditsEarned: "",
  loggedInWithModal: false,
};

const pending = "Pending";
const complete = "Complete";

const statusText = (status?: string, creditsGranted?: number) => {
  switch (status) {
    case pending:
      return {
        submissionHeader: "Review Pending",
        submissionMessage: "We received your submission and are reviewing it",
        creditsEarned: "",
      };
    case complete:
      return {
        submissionHeader: "Review Complete - Thank You!",
        submissionMessage: creditsGranted ? `Credits earned:` : "",
        creditsEarned: formatAsCurrency.formatIfUndefined(
          creditsGranted,
          true,
          true,
        ),
      };
    default:
      return { submissionHeader: "", submissionMessage: "", creditsEarned: "" };
  }
};

const reviewStarted = (status?: string) => {
  return status === pending || status === complete;
};

const reviewStatusReducer = (state: StatusState, action: StatusAction) => {
  switch (action.type) {
    case "FETCH_STATUS":
      return {
        ...state,
        showSubmissionMessage: reviewStarted(action.payload?.reviewStatus),
        ...statusText(
          action.payload?.reviewStatus,
          action.payload?.creditsGranted,
        ),
        statusFetchComplete: true,
        loggedInWithModal:
          state.loggedInWithModal &&
          !reviewStarted(action.payload?.reviewStatus),
      };
    case "REVIEW_SUBMISSION":
      return {
        ...state,
        showSubmissionMessage: true,
        loggedInWithModal: false,
        ...statusText(pending),
      };
    case "FETCH_ERROR":
      return {
        ...state,
        statusFetchComplete: false,
      };
    case "MODAL_LOGIN":
      return {
        ...state,
        loggedInWithModal: action.payload?.loggedInWithModal,
      };
    case "RESET_STATUS":
      return defaultStatusState;
    default:
      return defaultStatusState;
  }
};

export default reviewStatusReducer;
